import React from 'react';
import {
	Card, Input, Button, Table, Modal, Form, InputNumber, Switch, Spin, Divider,
	message, Tag, Tooltip, Typography, Pagination,
} from 'antd';
import {
	SearchOutlined, PlusOutlined, FormOutlined, CloseSquareOutlined,
	ExclamationCircleOutlined, DiffOutlined, RedoOutlined, ToolOutlined,
	UndoOutlined, SaveOutlined, CloseCircleOutlined, EditOutlined, PlusCircleOutlined,
	TagOutlined, PercentageOutlined, CheckOutlined, CloseOutlined,
} from '@ant-design/icons';
import { connect } from 'react-redux';
import { initHandler, ajaxViewHandler, ajaxHandler, setConfig } from '../../store/actions';
import Config from '../../Config';
import { Helmet } from 'react-helmet';
import ErrorAlertModal from '../../components/ErrorAlertModal';

const { Text } = Typography;

const configClass = {
	title : 'Data Fungsi',
	apiUrl: { data: 'master/api/fungsi/' },
};

const config = new Config();

class DataFungsi extends React.Component {
	formModalRef = React.createRef();

	constructor(props) {
		super(props);
		this.state = {
			errMsg    : '',
			errTitle  : '',
			loadingData: false,
			pagination: { pageSize: 25, current: 1, total: 0 },
			searchText: '',
			dataSource: [],
			isMobile  : window.innerWidth <= 768,
			modalVisible      : false,
			modalMode         : 'tambah',
			modalEditId       : null,
			modalLoadingData  : false,
			modalLoadingSubmit: false,
		};
		this._searchTimer = null;
	}

	UNSAFE_componentWillMount() { this.props.initHandler(); }

	componentDidMount() {
		this.getData();
		this._handleResize = () => this.setState({ isMobile: window.innerWidth <= 768 });
		window.addEventListener('resize', this._handleResize);
	}

	componentWillUnmount() {
		window.removeEventListener('resize', this._handleResize);
		clearTimeout(this._searchTimer);
	}

	showRestoreConfirm(id) {
		Modal.confirm({
			title: 'Aktifkan Fungsi', icon: <UndoOutlined style={{ color: '#52c41a' }} />,
			content: 'Data fungsi akan diaktifkan kembali.',
			okText: 'Aktifkan', okButtonProps: { style: { background: '#52c41a', borderColor: '#52c41a' } },
			cancelText: 'Batal', onOk: () => this.prosesRestore(id),
		});
	}

	prosesRestore(id) {
		message.loading({ content: 'Mengaktifkan...', key: 'toast' });
		this.props.ajaxHandler('post', configClass.apiUrl.data + id + '/restore/', {}, false, true)
			.then(() => {
				if (this.props.isSuccess) {
					message.success({ content: 'Data fungsi berhasil diaktifkan kembali', duration: 2, key: 'toast' });
					this.getData();
				} else {
					message.error({ content: 'Gagal mengaktifkan data', duration: 2, key: 'toast' });
				}
			})
			.catch(() => message.error({ content: 'Kesalahan pengiriman data, coba lagi', duration: 2, key: 'toast' }));
	}

	showDeleteConfirm(id) {
		Modal.confirm({
			title: 'Nonaktifkan Fungsi', icon: <ExclamationCircleOutlined />,
			content: 'Data fungsi akan dinonaktifkan. Data tetap tersimpan dan dapat diaktifkan kembali.',
			okText: 'Nonaktifkan', okType: 'danger', cancelText: 'Batal', onOk: () => this.prosesHapus(id),
		});
	}

	prosesHapus(id) {
		message.loading({ content: 'Menonaktifkan...', key: 'toast' });
		this.props.ajaxHandler('delete', configClass.apiUrl.data + id + '/')
			.then(() => {
				if (this.props.isSuccess) {
					message.success({ content: 'Data fungsi berhasil dinonaktifkan', duration: 2, key: 'toast' });
					this.getData();
				} else {
					message.error({ content: 'Gagal menonaktifkan data', duration: 2, key: 'toast' });
					this.setState({ errTitle: 'Gagal menonaktifkan data', errMsg: this.props.responseMsg });
				}
			})
			.catch(() => message.error({ content: 'Kesalahan pengiriman data, coba lagi', duration: 2, key: 'toast' }));
	}

	async getData(limit = this.state.pagination.pageSize, offset = 0, search = this.state.searchText) {
		this.setState({ loadingData: true });
		this.props.ajaxViewHandler('get', configClass.apiUrl.data + '?limit=' + limit + '&offset=' + offset + '&search=' + search + '&include_deleted=true')
			.then(() => {
				if (this.props.isSuccess) {
					const data = this.props.responseMsg;
					this.setState(prev => ({ dataSource: data.results, pagination: { ...prev.pagination, total: data.count } }));
				} else {
					this.setState({ errTitle: 'Gagal memuat data', errMsg: this.props.responseMsg });
					message.error({ content: 'Gagal memuat data', duration: 2, key: 'toast' });
				}
				this.setState({ loadingData: false });
			})
			.catch(() => { message.error({ content: 'Gagal request data, coba lagi', duration: 2, key: 'toast' }); this.setState({ loadingData: false }); });
	}

	handleSearchChange = (e) => {
		const val = e.target.value;
		this.setState({ searchText: val });
		clearTimeout(this._searchTimer);
		this._searchTimer = setTimeout(() => {
			this.setState(prev => ({ pagination: { ...prev.pagination, current: 1 } }));
			this.getData(this.state.pagination.pageSize, 0, val);
		}, 400);
	};

	handleTableChange = (pagination) => {
		this.setState({ pagination: { ...this.state.pagination, pageSize: pagination.pageSize, current: pagination.current } });
		this.getData(pagination.pageSize, (pagination.current - 1) * pagination.pageSize);
	};

	handleMobilePageChange = (page, pageSize) => {
		this.setState(prev => ({ pagination: { ...prev.pagination, current: page, pageSize } }));
		this.getData(pageSize, (page - 1) * pageSize);
	};

	openAddModal = () => {
		this.setState({ modalVisible: true, modalMode: 'tambah', modalEditId: null });
		if (this.formModalRef.current) this.formModalRef.current.resetFields();
	}

	openEditModal = (id) => {
		this.setState({ modalVisible: true, modalMode: 'edit', modalEditId: id, modalLoadingData: true });
		if (this.formModalRef.current) this.formModalRef.current.resetFields();
		this.props.ajaxViewHandler('get', configClass.apiUrl.data + id + '/')
			.then(() => {
				if (this.props.isSuccess) {
					const d = this.props.responseMsg;
					this.setState({ modalLoadingData: false }, () => {
						if (this.formModalRef.current) {
							this.formModalRef.current.setFieldsValue({
								nama: d.nama, kode: d.kode,
								plat_merah: d.plat_merah, plat_putih: d.plat_putih,
								keringanan: d.keringanan,
							});
						}
					});
				} else {
					this.setState({ modalLoadingData: false });
					message.error({ content: 'Gagal memuat data', duration: 2, key: 'toast' });
				}
			})
			.catch(() => { this.setState({ modalLoadingData: false }); message.error({ content: 'Gagal memuat data', duration: 2, key: 'toast' }); });
	}

	closeModal = () => {
		if (this.state.modalLoadingSubmit) return;
		this.setState({ modalVisible: false, modalEditId: null });
		if (this.formModalRef.current) this.formModalRef.current.resetFields();
	}

	handleModalSubmit = (values) => {
		const { modalMode, modalEditId } = this.state;
		const method = modalMode === 'edit' ? 'put' : 'post';
		const url    = modalMode === 'edit' ? configClass.apiUrl.data + modalEditId + '/' : configClass.apiUrl.data;
		this.setState({ modalLoadingSubmit: true });
		message.loading({ content: 'Menyimpan...', key: 'toast' });
		this.props.ajaxHandler(method, url, values, false, true)
			.then(() => {
				this.setState({ modalLoadingSubmit: false });
				if (this.props.isSuccess) {
					message.success({ content: 'Data berhasil disimpan', duration: 2, key: 'toast' });
					this.closeModal();
					this.getData();
				} else {
					message.destroy();
					this.setState({ errTitle: 'Gagal menyimpan data', errMsg: this.props.responseMsg });
				}
			})
			.catch(() => { this.setState({ modalLoadingSubmit: false }); message.error({ content: 'Kesalahan jaringan', duration: 2, key: 'toast' }); });
	}

	renderModal() {
		const { modalVisible, modalMode, modalLoadingData, modalLoadingSubmit, isMobile } = this.state;
		const isEdit = modalMode === 'edit';
		const header = (
			<div style={{ background: 'linear-gradient(135deg, #0f2847 0%, #1e4d8a 60%, #0a3d6b 100%)', borderRadius: isMobile ? 0 : '8px 8px 0 0', padding: isMobile ? '14px 18px' : '20px 28px', display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 14 }}>
				<div style={{ display: 'flex', alignItems: 'center', gap: 14 }}>
					<div style={{ width: isMobile ? 36 : 44, height: isMobile ? 36 : 44, flexShrink: 0, borderRadius: 10, background: 'rgba(255,255,255,0.15)', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
						{isEdit ? <EditOutlined style={{ color: '#fff', fontSize: isMobile ? 16 : 20 }} /> : <PlusCircleOutlined style={{ color: '#fff', fontSize: isMobile ? 16 : 20 }} />}
					</div>
					<div>
						<div style={{ color: '#fff', fontWeight: 700, fontSize: isMobile ? 14 : 16 }}>{isEdit ? 'Edit Fungsi' : 'Tambah Fungsi'}</div>
						{!isMobile && <div style={{ color: 'rgba(255,255,255,0.65)', fontSize: 12, marginTop: 2 }}>{isEdit ? 'Ubah informasi fungsi kendaraan' : 'Isi formulir untuk menambah fungsi baru'}</div>}
					</div>
				</div>
				<Button type="text" icon={<CloseCircleOutlined style={{ fontSize: 18 }} />} onClick={this.closeModal} disabled={modalLoadingSubmit} style={{ color: 'rgba(255,255,255,0.8)', padding: 4 }} />
			</div>
		);
		const formBody = (
			<div style={{ padding: isMobile ? '18px 16px 0' : '24px 28px 0' }}>
				{modalLoadingData ? (
					<div style={{ textAlign: 'center', padding: isMobile ? 36 : 52 }}><Spin size="large" /><div style={{ marginTop: 12, color: '#888', fontSize: 13 }}>Memuat data...</div></div>
				) : (
					<Form ref={this.formModalRef} layout="vertical" onFinish={this.handleModalSubmit}>
						<Form.Item label={<span><ToolOutlined style={{ color: '#1e4d8a', marginRight: 6 }} />Nama Fungsi</span>} name="nama" rules={[{ required: true, message: 'Nama fungsi harus diisi' }]}>
							<Input placeholder="Nama fungsi kendaraan..." style={{ borderRadius: 8, height: 38 }} />
						</Form.Item>
						<Form.Item label={<span><TagOutlined style={{ color: '#1e4d8a', marginRight: 6 }} />Kode</span>} name="kode" rules={[{ required: true, message: 'Kode harus diisi' }]}>
							<Input placeholder="Kode fungsi..." style={{ borderRadius: 8, height: 38 }} />
						</Form.Item>
						<Form.Item label={<span><PercentageOutlined style={{ color: '#cf1322', marginRight: 6 }} />Plat Merah (%)</span>} name="plat_merah" rules={[{ required: true, message: 'Plat merah harus diisi' }]}>
							<InputNumber placeholder="0.00" min={0} max={999} precision={2} step={0.01} style={{ borderRadius: 8, height: 38, width: '100%' }} />
						</Form.Item>
						<Form.Item label={<span><PercentageOutlined style={{ color: '#595959', marginRight: 6 }} />Plat Putih (%)</span>} name="plat_putih" rules={[{ required: true, message: 'Plat putih harus diisi' }]}>
							<InputNumber placeholder="0.00" min={0} max={999} precision={2} step={0.01} style={{ borderRadius: 8, height: 38, width: '100%' }} />
						</Form.Item>
						<Form.Item label="Keringanan" name="keringanan" valuePropName="checked" style={{ marginBottom: 0 }}>
							<Switch checkedChildren={<><CheckOutlined /> Ya</>} unCheckedChildren={<><CloseOutlined /> Tidak</>} />
						</Form.Item>
					</Form>
				)}
			</div>
		);
		const footer = !modalLoadingData && (
			<div>
				<Divider style={{ margin: '16px 0 0' }} />
				<div style={{ padding: isMobile ? '14px 16px' : '16px 28px', display: 'flex', flexDirection: isMobile ? 'column-reverse' : 'row', justifyContent: isMobile ? 'stretch' : 'flex-end', gap: 10, background: '#fafafa', borderRadius: isMobile ? 0 : '0 0 8px 8px' }}>
					<Button icon={<CloseCircleOutlined />} onClick={this.closeModal} disabled={modalLoadingSubmit} style={{ borderRadius: 8, height: 40, width: isMobile ? '100%' : 'auto' }}>Batal</Button>
					<Button type="primary" icon={<SaveOutlined />} loading={modalLoadingSubmit} onClick={() => this.formModalRef.current && this.formModalRef.current.submit()} style={{ background: 'linear-gradient(135deg, #0f2847, #1e4d8a)', border: 'none', borderRadius: 8, fontWeight: 600, height: 40, width: isMobile ? '100%' : 'auto' }}>
						{isEdit ? 'Simpan Perubahan' : 'Tambah Fungsi'}
					</Button>
				</div>
			</div>
		);
		return (
			<Modal visible={modalVisible} onCancel={this.closeModal} footer={null} title={null} closable={false} width={isMobile ? 'calc(100vw - 16px)' : 520} style={isMobile ? { top: 12, margin: '0 8px' } : { top: 60 }} bodyStyle={{ padding: 0 }} maskClosable={!modalLoadingSubmit} destroyOnClose>
				{header}{formBody}{footer}
			</Modal>
		);
	}

	_buildColumns() {
		return [
			{ title: 'No', key: 'no', width: 56, align: 'center', render: (_, __, index) => { const { pagination } = this.state; return <Text style={{ fontSize: 12, color: '#888' }}>{(pagination.current - 1) * pagination.pageSize + index + 1}</Text>; } },
			{
				title: 'Nama', dataIndex: 'nama', key: 'nama',
				render: (value) => (
					<div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
						<div style={{ width: 34, height: 34, borderRadius: 8, flexShrink: 0, background: 'linear-gradient(135deg, #0f2847, #1e4d8a)', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
							<ToolOutlined style={{ color: '#fff', fontSize: 15 }} />
						</div>
						<div style={{ fontWeight: 600, fontSize: 13, color: '#222' }}>{value || '—'}</div>
					</div>
				),
			},
			{ title: 'Kode', dataIndex: 'kode', key: 'kode', width: 120, align: 'center', render: (val) => <Tag style={{ borderRadius: 20, fontWeight: 600, fontSize: 12, background: '#e6f0fb', borderColor: '#91b4e8', color: '#1e4d8a', letterSpacing: 1 }}>{val || '—'}</Tag> },
			{ title: 'Plat Merah %', dataIndex: 'plat_merah', key: 'plat_merah', width: 140, align: 'center', render: (val) => val !== undefined && val !== null ? <Tag style={{ borderRadius: 20, fontWeight: 600, fontSize: 12, background: '#fff1f0', borderColor: '#ffa39e', color: '#cf1322', fontFamily: 'monospace' }}>{val}%</Tag> : <Text type="secondary">—</Text> },
			{ title: 'Plat Putih %', dataIndex: 'plat_putih', key: 'plat_putih', width: 140, align: 'center', render: (val) => val !== undefined && val !== null ? <Tag style={{ borderRadius: 20, fontWeight: 600, fontSize: 12, background: '#f5f5f5', borderColor: '#d9d9d9', color: '#595959', fontFamily: 'monospace' }}>{val}%</Tag> : <Text type="secondary">—</Text> },
			{
				title: 'Keringanan', dataIndex: 'keringanan', key: 'keringanan', width: 120, align: 'center',
				render: (val) => val
					? <Tag style={{ borderRadius: 20, fontWeight: 600, fontSize: 12, background: '#f6ffed', borderColor: '#b7eb8f', color: '#389e0d' }}>Ya</Tag>
					: <Tag style={{ borderRadius: 20, fontWeight: 600, fontSize: 12, background: '#f5f5f5', borderColor: '#d9d9d9', color: '#8c8c8c' }}>Tidak</Tag>,
			},
			{ title: 'Status', dataIndex: 'deleted_at', key: 'status', width: 110, align: 'center', render: (val) => val ? <Tag style={{ borderRadius: 20, fontWeight: 600, fontSize: 11, background: '#fff1f0', borderColor: '#ffa39e', color: '#cf1322' }}>Tidak Aktif</Tag> : <Tag style={{ borderRadius: 20, fontWeight: 600, fontSize: 11, background: '#f6ffed', borderColor: '#b7eb8f', color: '#389e0d' }}>Aktif</Tag> },
			{
				title: 'Aksi', key: 'aksi', width: 100, fixed: 'right', align: 'center',
				render: (_, row) => (
					<div style={{ display: 'flex', gap: 6, justifyContent: 'center' }}>
						<Tooltip title={row.deleted_at ? 'Aktifkan dulu untuk mengedit' : 'Edit'}>
							<Button size="small" shape="circle" type="primary" ghost disabled={!!row.deleted_at} onClick={() => !row.deleted_at && this.openEditModal(row.id)}><FormOutlined /></Button>
						</Tooltip>
						{!row.deleted_at ? (
							<Tooltip title="Nonaktifkan"><Button size="small" shape="circle" danger onClick={() => this.showDeleteConfirm(row.id)}><CloseSquareOutlined /></Button></Tooltip>
						) : (
							<Tooltip title="Aktifkan kembali"><Button size="small" shape="circle" style={{ background: '#f6ffed', borderColor: '#52c41a', color: '#52c41a' }} onClick={() => this.showRestoreConfirm(row.id)}><UndoOutlined /></Button></Tooltip>
						)}
					</div>
				),
			},
		];
	}

	renderMobileCard(row) {
		return (
			<Card key={row.id} style={{ borderRadius: 14, marginBottom: 12, boxShadow: '0 2px 12px rgba(0,0,0,0.07)', border: '1px solid #f0f0f0', overflow: 'hidden' }} bodyStyle={{ padding: 0 }}>
				<div style={{ background: 'linear-gradient(135deg, #0f284711, #1e4d8a11)', borderBottom: '1px solid #d0dff5', padding: '12px 16px', display: 'flex', alignItems: 'center', gap: 12 }}>
					<div style={{ width: 44, height: 44, borderRadius: 12, flexShrink: 0, background: 'linear-gradient(135deg, #0f2847, #1e4d8a)', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
						<ToolOutlined style={{ color: '#fff', fontSize: 20 }} />
					</div>
					<div style={{ flex: 1, minWidth: 0 }}>
						<div style={{ fontWeight: 700, fontSize: 15, color: '#0f2847', lineHeight: 1.3 }}>{row.nama || '—'}</div>
						<div style={{ display: 'flex', gap: 6, marginTop: 5, flexWrap: 'wrap' }}>
							{row.kode && <Tag style={{ borderRadius: 20, fontSize: 11, margin: 0, background: '#e6f0fb', borderColor: '#91b4e8', color: '#1e4d8a', fontWeight: 600 }}>{row.kode}</Tag>}
							{row.keringanan
								? <Tag style={{ borderRadius: 20, fontSize: 11, margin: 0, background: '#f6ffed', borderColor: '#b7eb8f', color: '#389e0d', fontWeight: 600 }}>Keringanan: Ya</Tag>
								: <Tag style={{ borderRadius: 20, fontSize: 11, margin: 0, background: '#f5f5f5', borderColor: '#d9d9d9', color: '#8c8c8c', fontWeight: 600 }}>Keringanan: Tidak</Tag>
							}
							{row.deleted_at
								? <Tag style={{ borderRadius: 20, fontSize: 11, margin: 0, background: '#fff1f0', borderColor: '#ffa39e', color: '#cf1322', fontWeight: 600 }}>Tidak Aktif</Tag>
								: <Tag style={{ borderRadius: 20, fontSize: 11, margin: 0, background: '#f6ffed', borderColor: '#b7eb8f', color: '#389e0d', fontWeight: 600 }}>Aktif</Tag>
							}
						</div>
					</div>
					<div style={{ display: 'flex', gap: 6 }}>
						<Tooltip title={row.deleted_at ? 'Aktifkan dulu untuk mengedit' : 'Edit'}>
							<Button size="middle" shape="circle" type="primary" ghost disabled={!!row.deleted_at} onClick={() => !row.deleted_at && this.openEditModal(row.id)}><FormOutlined /></Button>
						</Tooltip>
						{!row.deleted_at ? (
							<Tooltip title="Nonaktifkan"><Button size="middle" shape="circle" danger onClick={() => this.showDeleteConfirm(row.id)}><CloseSquareOutlined /></Button></Tooltip>
						) : (
							<Tooltip title="Aktifkan kembali"><Button size="middle" shape="circle" style={{ background: '#f6ffed', borderColor: '#52c41a', color: '#52c41a' }} onClick={() => this.showRestoreConfirm(row.id)}><UndoOutlined /></Button></Tooltip>
						)}
					</div>
				</div>
			</Card>
		);
	}

	render() {
		const { errMsg, errTitle, loadingData, dataSource, pagination, isMobile, searchText } = this.state;
		return (
			<div>
				<Helmet>
					<title>{configClass.title + ' | ' + config.get_site_info().name}</title>
					<style>{`
						.data-fungsi-wrap .ant-table-thead > tr > th { background: linear-gradient(135deg, #0f284711, #1e4d8a11) !important; font-weight: 700; font-size: 13px; color: #0f2847; border-bottom: 2px solid #d0dff5; }
						.data-fungsi-wrap .ant-table-tbody > tr > td { padding: 12px 16px; vertical-align: middle; }
						.data-fungsi-wrap .ant-table-tbody > tr:hover > td { background: #e8f0fb !important; }
						.data-fungsi-wrap .ant-table-tbody > tr:nth-child(even) > td { background: #fafafa; }
						.data-fungsi-wrap .ant-table-tbody > tr:nth-child(even):hover > td { background: #e8f0fb !important; }
						.data-fungsi-wrap .row-nonaktif > td { opacity: 0.55; background: #fff9f9 !important; }
						.data-fungsi-wrap .row-nonaktif:hover > td { opacity: 0.75 !important; background: #fff1f0 !important; }
						.data-fungsi-wrap .ant-form-item-label > label { font-weight: 600; color: #374151; font-size: 13px; }
						.data-fungsi-wrap .ant-input-number { width: 100% !important; }
					`}</style>
				</Helmet>
				<ErrorAlertModal visible={errMsg !== ''} title={errTitle} error={errMsg} onClose={() => this.setState({ errTitle: '', errMsg: '' })} />
				{this.renderModal()}
				<Card className="data-fungsi-wrap" style={{ borderRadius: 14, boxShadow: '0 4px 20px rgba(0,0,0,0.07)', overflow: 'hidden' }} bodyStyle={{ padding: 0 }}>
					<div style={{ padding: '16px 20px', background: 'linear-gradient(135deg, #0f2847, #1e4d8a)', display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap', gap: 10 }}>
						<div>
							<div style={{ color: '#fff', fontWeight: 700, fontSize: 17 }}><ToolOutlined style={{ marginRight: 8 }} />{configClass.title}</div>
							<div style={{ color: 'rgba(255,255,255,0.7)', fontSize: 12, marginTop: 2 }}>Total {pagination.total || 0} fungsi terdaftar{loadingData && ' · Memuat...'}</div>
						</div>
						<div style={{ display: 'flex', gap: 8 }}>
							<Tooltip title="Refresh data"><Button onClick={() => this.setState(prev => ({ searchText: '', pagination: { ...prev.pagination, current: 1 } }), () => this.getData(this.state.pagination.pageSize, 0, ''))} icon={<RedoOutlined />} style={{ borderRadius: 8, background: 'rgba(255,255,255,0.15)', border: 'none', color: '#fff' }}>{!isMobile && 'Refresh'}</Button></Tooltip>
							<Button type="primary" icon={<PlusOutlined />} onClick={this.openAddModal} style={{ borderRadius: 8, background: '#fff', color: '#0f2847', border: 'none', fontWeight: 600 }}>{isMobile ? 'Tambah' : 'Tambah Fungsi'}</Button>
						</div>
					</div>
					<div style={{ padding: '12px 20px', borderBottom: '1px solid #f0f0f0', background: '#fff', display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 12, flexWrap: 'wrap' }}>
						<Text type="secondary" style={{ fontSize: 12 }}>{loadingData ? 'Memuat data...' : `Menampilkan ${dataSource.length} dari ${pagination.total || 0} data`}</Text>
						<Input placeholder="Cari nama atau kode fungsi..." allowClear size="middle" prefix={<SearchOutlined style={{ color: '#bbb' }} />} style={{ borderRadius: 8, maxWidth: 340 }} value={searchText} onChange={this.handleSearchChange} onClear={() => this.setState(prev => ({ searchText: '', pagination: { ...prev.pagination, current: 1 } }), () => this.getData(this.state.pagination.pageSize, 0, ''))} />
					</div>
					<div style={{ padding: isMobile ? 12 : 0 }}>
						{isMobile ? (
							<div>
								{loadingData ? <div style={{ textAlign: 'center', padding: 40, color: '#aaa' }}>Memuat data...</div> : dataSource.length === 0 ? <div style={{ textAlign: 'center', padding: 40, color: '#aaa' }}>Tidak ada data</div> : dataSource.map(row => this.renderMobileCard(row))}
								{pagination.total > 0 && <div style={{ textAlign: 'center', padding: '12px 0 4px' }}><Pagination current={pagination.current} pageSize={pagination.pageSize} total={pagination.total} onChange={this.handleMobilePageChange} showSizeChanger={false} simple /></div>}
							</div>
						) : (
							<Table columns={this._buildColumns()} dataSource={dataSource} loading={loadingData} rowKey="id" scroll={{ x: 'max-content' }} size="middle" rowClassName={(row) => row.deleted_at ? 'row-nonaktif' : ''} pagination={{ current: pagination.current, pageSize: pagination.pageSize, total: pagination.total, showSizeChanger: true, pageSizeOptions: ['10', '25', '50', '100'], showTotal: (total, range) => `${range[0]}-${range[1]} dari ${total} data` }} onChange={this.handleTableChange} />
						)}
					</div>
				</Card>
			</div>
		);
	}
}

const mapStateToProps = (state) => state.configReducers;
export default connect(mapStateToProps, { initHandler, setConfig, ajaxViewHandler, ajaxHandler })(DataFungsi);
